import { useQuery } from '@apollo/client';
import GET_PAID_USERS from '../../../queries/paidLicensesQueries/getPaidUsers';

export const useUserPaidDataQuery = (orgId, orgUnitId, callback) => {
  const { error } = useQuery(GET_PAID_USERS, {
    variables: orgUnitId ? { orgUnitId } : { organizationId: orgId },
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      const callbackObject = {
        orgUsers: orgUnitId ? null : data.paidUsers.OrgUsers,
        orgLicenseCount: orgUnitId ? null : data.licenseInformation.Organization.licenseTotal,
        orgLicenseAssignedCount: orgUnitId
          ? null
          : data.licenseInformation.Organization.licenseAssigned,
        orgUnits: orgUnitId ? null : data.licenseInformation.OrgUnits,
        orgUnitUsers: data.paidUsers.OrgUnitUsers,
        orgUnitLicenseCount: orgUnitId && data.licenseInformation.OrgUnits[0].licenseTotal,
        orgUnitLicenseAssignedCount:
          orgUnitId && data.licenseInformation.OrgUnits[0].licenseAssigned
      };

      callback(callbackObject);
    }
  });

  return { error };
};
